// extracted by mini-css-extract-plugin
module.exports = {"Breadcrumbs":"breadcrumbsMobile_Breadcrumbs__Hd1oE","Line":"breadcrumbsMobile_Line__IbAZi","BreadcrumbsContainer":"breadcrumbsMobile_BreadcrumbsContainer__IFR9W"};